<template>
  <div class="perfil">
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <form
      class="content"
      v-if="!loader"
      onsubmit="return false;"
      @submit="SAVE_PERFIL({ ...perfil, retorno: true })"
    >
      <div class="title grid-12"><i class="fa fa-user"></i> &nbsp;Perfil</div>

      <div class="column section">
        <div class="row align-center column-s">
          <div
            class="picture grid-2 grid-12-s text-center"
            @click="modal.show = true"
          >
            <img
              v-if="
                user.link_foto_doutor &&
                user.perfil == 'doutor' &&
                user.link_foto_doutor != '/img/img_usuario_padrao.png'
              "
              :src="user.link_foto_doutor"
            />
            <img src="../../assets/img/usuario_padrao.png" v-else />
            <Button type="button" layout="green-s" @click="modal.show = true"
              >ALTERAR FOTO</Button
            >
          </div>

          <div class="row column-s wrap align-center grid-12">
            <div class="grid-3-g grid-12-s grid-5-m label column">
              <label>Nome</label>
              <input type="text" class="input" v-model="perfil.nome" required />
            </div>

            <div class="grid-3-g grid-4-m grid-12-s label column">
              <label>E-mail</label>
              <input
                type="email"
                class="input readonly"
                :value="perfil.email"
                readonly
              />
            </div>

            <div class="grid-2-g grid-3-m grid-12-s label column">
              <label>Celular</label>
              <input
                type="text"
                class="input"
                v-model="perfil.celular"
                v-mask="'(##) #####-####'"
                required
              />
            </div>

            <div class="grid-1 grid-12-s grid-3-m label column">
              <label>Sexo</label>
              <select class="input" v-model="perfil.sexo" required>
                <option value>Selecione</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
              </select>
            </div>
            <div class="grid-1 grid-12-s grid-3-m label column">
              <label>PcD</label>
              <select class="input" v-model="perfil.pcd" required>
                <option value>Selecione</option>
                <option value="N">Não</option>
                <option value="S">Sim</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="save row align-center">
        <div class="hide-s grid">
          <Button layout="white-m-gray" @click="router.back()" type="button">
            <i class="fa fa-arrow-left"></i> Voltar
          </Button>
        </div>
        <div class="grid-12 row justify-end justify-center-s">
          <Button layout="green-go" class="grid-12-s">SALVAR</Button>
        </div>
      </div>
    </form>
    <Loader v-else />

    <Modal :modal="modal" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import Modal from "@/components/Modal";
import Router from "@/router";
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

export default {
  name: "Perfil",
  components: { Button, Loader, Modal },
  data() {
    return {
      loader: true,
      router: Router,
      midia: "",
      modal: {
        show: false,
        title: "Alterar foto",
        layout: "Files",
        pendency: {
          tipo_arquivo: "5_foto_doutor",
        },
        cb: (midia) => {
          this.modal.show = false;
          this.user.link_foto_doutor = midia;
          this.perfil.foto_doutor = true;
          this.SET_USER(this.user);
        },
      },
    };
  },
  methods: {
    ...mapActions("user", ["LOAD_PERFIL_SUPPORTER", "SAVE_PERFIL"]),
    ...mapMutations("user", ["SET_USER"]),
    cep() {
      if (this.perfil.cep.length > 9)
        this.LOAD_CEP(this.perfil.cep.replace(".", "").replace("-", "")).then(
          (r) => {
            if (r.logradouro) {
              this.perfil.logradouro = r.logradouro;
              this.perfil.bairro = r.bairro;
              this.perfil.cidade = r.localidade;
              this.perfil.estado = r.uf;
            }
          }
        );
    },
  },
  beforeMount() {
    this.LOAD_PERFIL_SUPPORTER().then(() => {
      this.loader = false;
    });
  },
  computed: {
    ...mapGetters("user", ["perfil", "user"]),
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.perfil {
  padding: 0 30px;
  color: $black;
  input,
  select {
    background: $white;
  }
  .content {
    border-radius: 21px;
    background: $white;
    box-shadow: $shadow;
    padding: 32px 35px;

    .title {
      font-size: 26px;
      margin-bottom: 30px;
      color: $blue-4;
      font-weight: bold;
    }

    .sub {
      font-size: 14px;
      padding: 15px 0;
      font-weight: 500;
      margin-top: 30px;
      color: $orange;
      @media (max-width: $small) {
        font-size: 17px;
        text-align: center;
      }
    }

    .label {
      color: $gray-6;
      font-size: 13px;
      font-weight: 300;
      margin-bottom: 25px;
      padding-right: 15px;
      select {
        width: 100%;
      }
      div {
        color: $gray-7;
        font-size: 17px;
        font-weight: 500;
        text-transform: capitalize;
        line-height: 42px;
      }
    }
    .section {
      padding-bottom: 12px;
    }
    .picture {
      padding: 0 6px;

      @media (min-width: $small) {
        margin-right: 50px;
      }
      @media (max-width: $small) {
        margin-bottom: 30px;
      }

      img {
        width: 100%;
        cursor: pointer;
        border-radius: 50%;
      }
    }
    .save {
      margin-top: 30px;
    }
  }
  .loader {
    left: 50%;
    margin-left: -45px;
    margin-top: 15%;
  }
  @media (max-width: $small) {
    padding: 7px;
  }
}
</style>
